
//--------------- IMPORTAÇÕES ---------------//
import { useContext, useEffect } from "react";
import { formatterCurrency } from "../../../shared/utils";
import { TrackingContext } from "../context/TrackingContext";



//--------------- EXPORTAÇÃO DO COMPONENTE CONTAINER CREATE COMPANY ---------------//
export default function ContainerResumeCards() {



    //--------------- CRIAÇÃO DOS HOOKS ---------------//
    const {events, setEvents} = useContext(TrackingContext);



    useEffect(() => {

    }, []);







    //--------------- RETORNO DO COMPONENTE CONTAINER CREATE COMPANY ---------------//
    return (
        <>

            {/* DIV DATA RESUME */}
            <div className="grid md:grid-cols-4 gap-4 mb-8 w-full">


                {/* DIV DA RECEITA LÍQUIDA */}
                <div className="bg-surface-2 p-4 rounded-xl border border-blue-500 w-full">
                    <h2 className="text-blue-400 font-semibold mb-2"><b>Visitantes</b></h2>
                    <h1 className="text-white font-semibold">Total: <b>{events.visitantes ? events.visitantes : (<i class="fas fa-circle-notch fa-spin opacity-70"></i>)}</b></h1>
                    <p className="text-ink-3 font-semibold mb-1 text-xs">usuários únicos com ao menos um pageview</p>
                </div>


                {/* DIV DAS DESPESAS */}
                <div className="bg-surface-2 p-4 rounded-xl border border-brand-500 w-full">
                    <h2 className="text-brand-400 font-semibold mb-2"><b>Leads</b></h2>
                    <h1 className="text-white font-semibold mb-1">Total: <b>{events.leads ? events.leads : (<i class="fas fa-circle-notch fa-spin opacity-70"></i>)}</b></h1>
                    <p className="text-ink-3 font-semibold mb-1 text-xs">{events.leads_por_visitantes ? events.leads_por_visitantes : (<i class="fas fa-circle-notch fa-spin opacity-70"></i>)}% dos visitantes</p>
                </div>


                {/* DIV DA RECEITA BRUTA */}
                <div className="bg-surface-2 p-4 rounded-xl border border-yellow-500 w-full">
                    <h2 className="text-yellow-400 font-semibold mb-2"><b>Checkout</b></h2>
                    <h1 className="text-white font-semibold">Total: <b>{events.checkouts ? events.checkouts : (<i class="fas fa-circle-notch fa-spin opacity-70"></i>)}</b></h1>
                    <p className="text-ink-3 font-semibold mb-1 text-xs">usuários únicos que fizeram checkout</p>
                </div>

                {/* DIV DA RECEITA BRUTA */}
                <div className="bg-surface-2 p-4 rounded-xl border border-orange-500 w-full">
                    <h2 className="text-orange-400 font-semibold mb-2"><b>Vendas</b></h2>
                    <h1 className="text-white font-semibold mb-1">Total: <b>{events.vendas ? events.vendas : (<i class="fas fa-circle-notch fa-spin opacity-70"></i>)}</b></h1>
                    <p className="text-ink-3 font-semibold mb-1 text-xs">R$ {events.vendas_valor ? events.vendas_valor : (<i class="fas fa-circle-notch fa-spin opacity-70"></i>)}</p>
                </div>

                {/* DIV DA RECEITA BRUTA */}
                <div className="bg-surface-2 p-4 rounded-xl border border-red-500 w-full">
                    <h2 className="text-red-400 font-semibold mb-2"><b>Orderbumps</b></h2>
                    <h1 className="text-white font-semibold mb-1">Total: <b>{events.orderbumps ? events.orderbumps : (<i class="fas fa-circle-notch fa-spin opacity-70"></i>)}</b></h1>
                    <p className="text-ink-3 font-semibold mb-1 text-xs">R$ {events.orderbumps_valor ? events.orderbumps_valor : (<i class="fas fa-circle-notch fa-spin opacity-70"></i>)}</p>
                </div>

                {/* DIV DA RECEITA BRUTA */}
                <div className="bg-surface-2 p-4 rounded-xl border border-green-500 w-full">
                    <h2 className="text-green-400 font-semibold mb-2"><b>Receita Total</b></h2>
                    <h1 className="text-white font-semibold mb-1">Total: <b>000</b></h1>
                </div>


            </div>

        </>
    )
}